import { useStorage } from "app/custom-hooks/storage/useStorage";
import { SdkFeatureUpgradeBanner } from "app/pages/sales-intelligence/common-components/feature-upgrade";
import { appsSearchSessionStorage } from "app/pages/sales-intelligence/modules/apps-search/services/storage";

export const SdkUpgradeView = () => {
    const [isSubmitted, setSubmitted] = useStorage(appsSearchSessionStorage.sdkFilterHookSubmitted);

    return (
        <SdkFeatureUpgradeBanner
            isSubmitted={isSubmitted}
            onSubmit={() => setSubmitted(true)}
        />
    );
};
